export class SalesPlan {

    static round(no) {
        no = this.ifNaN(no);
        no = Math.round(no*100)/100;
        return no;
    }

    static doRound(data) {
        data.sales_per = this.round(data.sales_per);
        data.order_target = this.round(data.order_target);
    }

    static ifNaN(no) {
        no = (isNaN(no) && !isFinite(no)) ? 0 : no;
        return no;
    }

    static calcOT(q, p) {
        let r = 0;
        q = this.ifNaN(q);
        p = this.ifNaN(p);
        if (p > 0) {
            r = q / p * 100;
        } else {
            r = q;
        }
        return this.ifNaN(r);
    }

    static findOT(data) {
        let st = data.sales_target,
            op = data.order_per;
        data.order_target = this.calcOT(st, op);
    }

    static calcSP(ot, ao) {
        let sp = this.ifNaN(ot / ao * 100);
        sp = isFinite(sp)?sp:0;
        return sp;
    }

    static doCalcOTSP(data){
        this.findOT(data);
        let agents = data.agents,
            op = data.order_per,
            seasons = data.seasons;



        // Season List
        for (let i = 0; i < seasons.length; i++) {
            let season = seasons[i];
            this.findOT(season);
            season.sales_per = this.calcSP(season.order_target, data.order_target);
        }

        // Agent List 
        for (let i = 0; i < agents.length; i++) {
            let agent = agents[i],
                agentParty = agent.party,
                agentSeasons = agent.seasons;
            this.findOT(agent);
            agent.sales_per = this.calcSP(agent.order_target, data.order_target);

            // Agemt sSeasons
            for (let j = 0; j < agentSeasons.length; j++) {
                let season = agentSeasons[j];
                this.findOT(season);
                season.sales_per = this.calcSP(season.order_target, seasons[j].order_target);
            }

            // Agent Party

            for (let j = 0; j < agentParty.length; j++) {
                let party = agentParty[j],
                    partySeasons = party.seasons;
                this.findOT(party);
                party.sales_per = this.calcSP(party.order_target, agent.order_target);

                // party Seasons
                for (let k = 0; k < partySeasons.length; k++) {
                    let season = partySeasons[k];
                    this.findOT(season);
                    season.sales_per = this.calcSP(season.order_target, agent.seasons[k].order_target);
                }
            }

        }
    }
    

    static doCalcTotal(data) {
        let agents = data.agents,
        seasons = data.seasons,
        dst_st = 0,
        dst_ot = 0,
        dst_sp = 0,
        dat_st = 0,
        dat_ot = 0,
        dat_sp = 0;

        // Season Wise
        for (let i = 0; i < seasons.length; i++) {
            let season = seasons[i],
                sat_sp = 0,
                sat_st = 0,
                sat_ot = 0;
                dst_st += season.sales_target,
                dst_ot += season.order_target,
                dst_sp += season.sales_per;

            for(let j=0;j<agents.length;j++) {
                let agent = agents[j];
                sat_sp += agent.seasons[i].sales_per;
                sat_st += agent.seasons[i].sales_target;
                sat_ot += agent.seasons[i].order_target;
            }
            season.sat_sp = this.round(sat_sp);
            season.sat_ot = this.round(sat_ot);
            season.sat_st = this.round(sat_st);
            season.sad_sp = this.round(100 - sat_sp);
            season.sad_ot = this.round(season.order_target - sat_ot);
            season.sad_st = this.round(season.sales_target - sat_st);
        }

        //Agent List
        for (let i = 0; i < agents.length; i++) {
            let agent = agents[i],
                ast_st = 0,
                ast_ot = 0,
                ast_sp = 0,
                apt_st = 0,
                apt_ot = 0,
                apt_sp = 0,
            agentSeasons = agent.seasons,
            agentParty = agent.party;


            dat_st += agent.sales_target,
            dat_ot += agent.order_target,
            dat_sp += agent.sales_per;
                
            
            //Agent Season List
            for (let j = 0; j < agentSeasons.length; j++) {
                let season = agentSeasons[j],
                spt_st = 0,
                spt_ot = 0,
                spt_sp = 0;
                ast_st += season.sales_target,
                ast_ot += season.order_target,
                ast_sp += season.sales_per;

                for (let k = 0; k < agentParty.length; k++) {
                    let party = agentParty[k];
                    spt_st += party.seasons[j].sales_target;
                    spt_ot += party.seasons[j].order_target;
                    spt_sp += party.seasons[j].sales_per;
                }
                season.spt_st = this.round(spt_st);
                season.spt_ot = this.round(spt_ot);
                season.spt_sp = this.round(spt_sp);
                season.spd_st = this.round(season.sales_target - spt_st);
                season.spd_ot = this.round(season.order_target - spt_ot);
                season.spd_sp = this.round(100 -spt_sp);
            }

            agent.ast_st = this.round(ast_st);
            agent.ast_ot = this.round(ast_ot);
            agent.ast_sp = this.round(ast_sp);

            agent.asd_st = this.round(agent.sales_target-ast_st);
            agent.asd_ot = this.round(agent.order_target-ast_ot);
            agent.asd_sp = this.round(100-ast_sp);

            // Agent Party List 
            for (let j = 0; j < agentParty.length; j++) {
                let party = agentParty[j],
                    partySeasons = party.seasons,
                    pst_st = 0,
                    pst_ot = 0,
                    pst_sp = 0;
                    apt_st += party.sales_target,
                    apt_ot += party.order_target,
                    apt_sp += party.sales_per;

                //Party Season List
                for (let k = 0; k < partySeasons.length; k++) {
                    let season = partySeasons[k];

                    pst_st += season.sales_target;
                    pst_sp += season.sales_per;
                    pst_ot += season.order_target;

                }
                party.pst_st = this.round(pst_st);
                party.pst_sp = this.round(pst_sp);
                party.pst_ot = this.round(pst_ot);

                party.psd_st = this.round(party.sales_target - pst_st);
                party.psd_sp = this.round(100 - pst_sp);
                party.psd_ot = this.round(party.order_target - pst_ot);  
            }
            agent.apt_st = this.round(apt_st);
            agent.apt_ot = this.round(apt_ot);
            agent.apt_sp = this.round(apt_sp);

            agent.apd_st = this.round(agent.sales_target-apt_st);
            agent.apd_ot = this.round(agent.order_target-apt_ot);
            agent.apd_sp = this.round(100-apt_sp);


        }

        data.dst_st = this.round(dst_st);
        data.dst_ot = this.round(dst_ot);
        data.dst_sp = this.round(dst_sp);
        data.dat_st = this.round(dat_st);
        data.dat_ot = this.round(dat_ot);
        data.dat_sp = this.round(dat_sp);

        data.dsd_st = this.round(data.sales_target-dst_st);
        data.dsd_ot = this.round(data.order_target-dst_ot);
        data.dsd_sp = this.round(100-dst_sp);
        data.dad_st = this.round(data.sales_target-dat_st);
        data.dad_ot = this.round(data.order_target-dat_ot);
        data.dad_sp = this.round(100-dat_sp);
    }

    static doCalcRound(data) {
        let agents = data.agents,
            seasons = data.seasons;
            this.doRound(data);
        // Season Wise
        for (let i = 0; i < seasons.length; i++) {
            let season = seasons[i];
            this.doRound(season);
        }

        // Agent List
        for (let i = 0; i < agents.length; i++) {
            let agent = agents[i],
                agentSeasons = agent.seasons,
                agentParty = agent.party;

            this.doRound(agent);
            // Agent Season List
            for (let j = 0; j < agentSeasons.length; j++) {
                let season = agentSeasons[j];
                this.doRound(season);
            }

            // Agent Party List 
            for (let j = 0; j < agentParty.length; j++) {
                let party = agentParty[j],
                    partySeasons = party.seasons;
                this.doRound(party);
                // Party Season List
                for (let k = 0; k < partySeasons.length; k++) {
                    let season = partySeasons[k];
                    this.doRound(season);
                }
            }
        }
    }
    static doCalc(data) {
        this.doCalcOTSP(data);
        this.doCalcTotal(data);
        this.doCalcRound(data);
    }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/common/SalesPlan.ts